module.exports = __webpack_public_path__ + "media/application/images/svgs/logo-mono-4c6570811caec57a2752547e14504df4.svg";